import React from "react";

export const formatINRShort = (v) => {
  const n = Number(v || 0);
  if (n >= 10000000) return `\u20B9${(n / 10000000).toFixed(2)}Cr`;
  if (n >= 100000) return `\u20B9${(n / 100000).toFixed(2)}L`;
  if (n >= 1000) return `\u20B9${(n / 1000).toFixed(1)}k`;
  return `\u20B9${Math.round(n).toLocaleString("en-IN")}`;
};
export const formatINR = (v) => `\u20B9${Math.round(Number(v || 0)).toLocaleString("en-IN")}`;

export const StatusPill = ({ status }) => (
  <span className={`adm-pill ${status}`}>
    <span className="dot" /> {status}
  </span>
);

export const fmtDate = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "2-digit" });
  } catch { return ""; }
};
export const fmtDateTime = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch { return ""; }
};

export const Sparkline = ({ data, color = "#8B5CF6", width = 110, height = 36 }) => {
  if (!data || data.length === 0) return <svg width={width} height={height} />;
  const vals = data.map((d) => Number(d.revenue ?? d));
  const max = Math.max(...vals, 1);
  const min = Math.min(...vals, 0);
  const rng = max - min || 1;
  const step = width / Math.max(vals.length - 1, 1);
  const pts = vals.map((v, i) => `${i * step},${height - ((v - min) / rng) * (height - 4) - 2}`).join(" ");
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
      <polyline fill="none" stroke={color} strokeWidth="1.5" points={pts} />
    </svg>
  );
};

export const Toaster = ({ toasts }) => (
  <div className="adm-toast-stack">
    {toasts.map((t) => (
      <div key={t.id} className={`adm-toast ${t.kind}`}>
        {t.msg}
      </div>
    ))}
  </div>
);
